import React, { createContext, useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { getAllUsers } from '../services/usersService';
import Notification from '../components/Common/Notification';

export const UsersContext = createContext();

export const UsersProvider = ({ children }) => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  const [users, setUsers] = useState([]);
  const [notification, setNotification] = useState({ message: '', isError: false });

  const fetchAuthHeaders = () => {
    const storedUser = localStorage.getItem('user');
    const token = user?.token || (storedUser ? JSON.parse(storedUser).token : '');

    if (!token) {
      console.error('User or token not available');
      return {};
    }

    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  };

  const showNotification = (message, isError) => {
    setNotification({ message, isError });
  };

  const closeNotification = () => {
    setNotification({ message: '', isError: false });
  };

  const fetchAllUsers = async () => {
    try {
      const authHeaders = fetchAuthHeaders();
      const data = await getAllUsers(authHeaders);
      setUsers(data);
    } catch (error) {
      const errorMessage = error?.response?.data?.error || error?.response?.data?.message || 'Error fetching users.';
      showNotification(errorMessage, true);
    }
  };

  // useEffect(() => {
  //   if (user) {
  //     fetchAllUsers();
  //   }
  // }, [user]);


  useEffect(() => {
    if (!isAuthenticated && !['/', '/login'].includes(window.location.pathname)) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);


  return (
    <UsersContext.Provider
      value={{
        users,
        fetchAllUsers,
      }}
    >
      {children}
      {notification.message && (
        <Notification
          message={notification.message}
          isError={notification.isError}
          onClose={closeNotification}
        />
      )}
    </UsersContext.Provider>
  );
};

export const useUsers = () => useContext(UsersContext);
